export enum WorkflowFamily {
  Ingest = "Ingest",
  PurgeMediaFile = "PurgeMediaFile",
  BypassRejection = "BypassRejection",
  Delivery = "Delivery",
  Internal = "Internal",
  QualityCheck = "QualityCheck",
  Generic = "Generic",
}
